import { apiClient, WHOLE_USE_MOCK } from './api';
import {dataPermissions} from "../mock/mockDataPermissionData";
import { API_ENDPOINTS } from '../utils/apiEndpoints';

class DataPermissionService {
  /**
   * 获取数据权限列表
   */
  async getDataPermissions(params) {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      let filteredPermissions = [...dataPermissions];

      // 根据查询条件过滤
      if (params.code) {
        filteredPermissions = filteredPermissions.filter(permission =>
            permission.code.toLowerCase().includes(params.code.toLowerCase())
        );
      }

      if (params.nameLike) {
        filteredPermissions = filteredPermissions.filter(permission =>
            permission.name.includes(params.nameLike)
        );
      }

      const pageSize = params.pageSize || 10;
      const currentPage = params.currentPage || 1;
      const startIndex = (currentPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      const paginatedPermissions = filteredPermissions.slice(startIndex, endIndex);

      return {
        traceId: "75f33c8a3d564eccac6a74aa05c6e644",
        success: true,
        msg: null,
        errorCode: null,
        errorMessage: null,
        flag: "success",
        code: null,
        message: null,
        properties: {},
        data: {
          list: paginatedPermissions,
          pageNum: currentPage,
          pageSize: pageSize,
          total: filteredPermissions.length
        }
      };
    } else {
      return apiClient.post(API_ENDPOINTS.DATA_PERMISSION.PAGE, params);
    }
  }

  /**
   * 创建数据权限
   */
  async createDataPermission(data) {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      const newDataPermission = {
        ...data,
        id: dataPermissions.length + 1000 + 1,
        dataType: 1,
        isIncludeChildCode: false,
        creatorName: "当前用户",
        creatorAccount: "admin",
        gmtCreate: new Date().getTime(),
        gmtModified: new Date().getTime(),
        modifierName: null,
        modifierAccount: null,
        deleted: false
      };

      dataPermissions.push(newDataPermission);

      return {
        traceId: "75f33c8a3d564eccac6a74aa05c6e644",
        success: true,
        msg: null,
        errorCode: null,
        errorMessage: null,
        flag: "success",
        code: null,
        message: null,
        properties: {},
        data: newDataPermission
      };
    } else {
      return apiClient.post(API_ENDPOINTS.DATA_PERMISSION.CREATE, data);
    }
  }

  /**
   * 更新数据权限
   */
  async updateDataPermission(id, data) {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      const requestData = {
        id: data.id,
        name: data.name,
        code: data.code,
        sourceCode: data.sourceCode,
        bizDataCodes: data.bizDataCodes
      };

      const index = dataPermissions.findIndex(p => p.id === requestData.id);
      if (index === -1) {
        return {
          traceId: "75f33c8a3d564eccac6a74aa05c6e644",
          success: false,
          errorMessage: "数据权限不存在",
          flag: "fail",
          data: null
        };
      }

      const updatedPermission = {
        ...dataPermissions[index],
        ...requestData,
        modifierName: "当前用户",
        modifierAccount: "admin",
        gmtModified: new Date().getTime()
      };

      dataPermissions[index] = updatedPermission;

      return {
        traceId: "75f33c8a3d564eccac6a74aa05c6e644",
        success: true,
        msg: null,
        errorCode: null,
        errorMessage: null,
        flag: "success",
        code: null,
        message: null,
        properties: {},
        data: updatedPermission
      };

    } else {
      const requestData = {
        id: data.id,
        name: data.name,
        code: data.code,
        sourceCode: data.sourceCode,
        bizDataCodes: data.bizDataCodes
      };

      return apiClient.post(API_ENDPOINTS.DATA_PERMISSION.UPDATE, requestData);
    }
  }

  /**
   * 删除数据权限
   */
  async deleteDataPermission(code) {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      const index = dataPermissions.findIndex(p => p.code === code);
      if (index === -1) {
        return {
          traceId: "75f33c8a3d564eccac6a74aa05c6e644",
          success: false,
          errorMessage: "数据权限不存在",
          flag: "fail",
          data: null
        };
      }

      dataPermissions.splice(index, 1);

      return {
        traceId: "75f33c8a3d564eccac6a74aa05c6e644",
        success: true,
        msg: null,
        errorCode: null,
        errorMessage: null,
        flag: "success",
        code: null,
        message: null,
        properties: {},
        data: null
      };
    } else {
      return apiClient.post(API_ENDPOINTS.DATA_PERMISSION.DELETE, { code });
    }
  }
}

export const dataPermissionService = new DataPermissionService(); 